<template>
  <div>
    <base-header class="header pb-5 pt-5 pt-lg-8 d-flex align-items-center" type="gradient-live"></base-header>

    <div class="container-fluid mt--6" :class="{loading:carregando}">
         <div class="col-12">
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <div class="row align-items-center">
                <div class="col-12">
                  <h3 class="mb-0">Elemento '{{campos.nomeGrupo.value ? campos.nomeGrupo.value : '?'}}'</h3>
                </div>
              </div>
            </div>
            <template>
              <form @submit.prevent class="col-xl-12" enctype="multipart/form-data">
                <flow-form :campos="campos">
                  <div class="listaDefinicoes" slot="definicoes">
                    <div class="definicao row col-12 p-0 m-0" :class="{inativo: !def.status}" v-for="(def,idx) in campos.definicoes.value" :key="'def_'+idx">
                      <base-switch v-model="def.status" class="status mr-2"></base-switch>
                      <base-input class="ml-2 grow" type="text" label="Nome do Parâmetro" :required="true" :ref="'df_'+idx" v-model="def.nome" @keypress.enter="novo(campos.definicoes)" :inputClasses="'form-control-alternative'"></base-input>
                      <base-input class="ml-2 grow" type="text" label="Valor" :required="true" :ref="'df_'+idx" v-model="def.valor" @keypress.enter="novo(campos.definicoes)" :inputClasses="'form-control-alternative'"></base-input>
                      <base-button @click="remover(campos.definicoes,idx)" type="danger" size="md" icon="fas fa-trash" class="remover ml-2"></base-button>
                    </div>
                    <div class="d-center">
                      <base-button @click="novo(campos.definicoes)" outline>Novo parâmetro</base-button>
                    </div>
                  </div>
                </flow-form>
              </form>
            </template>
            <div slot="footer" class="row pr-2">
              <base-button type="primary" class="ml-auto" @click="salvar()">Salvar</base-button>
            </div>
          </card>
        </div>
    </div>
  </div>
</template>
<script>
import helpers from "@/cflow/helpers";
import parametros from "@/cflow/parametros";

export default {
  components: {
  },
  computed: {
  },
  data() {
    return {
      cadastro: 1,
      campos: {
        codigo: {
          size: 4,
          label: "Código",
          type: "text",
          value: null,
          disabled: true,
          required: true,
          error: "",
          class: "form-control-alternative",
        },
        nomeGrupo: {
          size: 8,
          label: "Nome do grupo",
          type: "text",
          value: null,
          required: true,
          error: "",
          class: "form-control-alternative",
          onInput: function(eu,campos){
            campos.codigo.value = helpers.camelCase(eu.value);
          }
        },
        definicoes: {
          label: "Definições",
          json: true,
          type: 'personalizado',
          value: [],
          required: true,
          error: "",
          class: "form-control-alternative",
          num: 1,
          modelo: {
            status: true,
            nome: null,
            valor: null
          }
        }
      },
      carregando: false,
    };
  },
  methods: {
    salvar: function () {
      var app = this;
      var objSalvar = helpers.dadosParaSalvar(app.campos);

      // Incluir o ID se ele foi passado, daí vai ser uma edição e não uma adição
      if (this.$route.params.id && this.$route.params.id !== 'novo') objSalvar.id = this.$route.params.id;

      // Envia tudo:
      parametros
        .salvar(objSalvar)
        .then(function () {
          // Deu certo, notificar:
          app.$notify({
            group: "geral",
            title: "Alterações salvas",
            text: "As informações foram salvas com sucesso",
            duration: 3000,
          });
        })
        .catch((error) => {
          // Deu errado, notificar:
          helpers.mostrarErros(app.campos, error.response.data, app);
        });
    },
    novo: function(campo){
      if('modelo' in campo){
        let modelo = helpers.copyJson(campo.modelo)
        modelo.valor = campo.num
        campo.num++
        campo.value.push(modelo)
        const app = this;
        setTimeout(function(){
          app.$refs['df_'+(campo.value.length-1)][0].$el.querySelector('input').focus()
        },50);
      }
    },
    remover: function(campo,idx){
      campo.value.splice(idx,1);
    }
  },
  mounted() {
    // Buscar as categorias no banco
    var app = this;

    // Se o id do feed for informado, carregar seus dados:
    helpers.preencherModelos(app.campos);
    if (this.$route.params.id && this.$route.params.id !== 'novo') {
      app.carregando = true;
      parametros.detalhes(this.$route.params.id).then((res) => {
        helpers.preencherCampos(app.campos, res);
        app.carregando = false;
      });
    }
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.definicao .form-group{
  transition: 0.2s;
}
.definicao.inativo .form-group{
  opacity: 0.5;
}
.definicao .remover{
  height: 43px;
  margin-top: 31px;
}
.definicao .status{
  margin-top: 41px;
}

</style>
